import { useEffect, useState } from "react"

const useBreakpoint = ({
  minWidth = 0,
  maxWidth = Infinity,
}: {
  minWidth?: number
  maxWidth?: number
}) => {
  const [enabled, setEnabled] = useState(false)

  useEffect(() => {
    const checkEnabled = () => {
      setEnabled(window.innerWidth >= minWidth && window.innerWidth <= maxWidth)
    }

    checkEnabled()

    window.addEventListener("resize", checkEnabled)

    return () => window.removeEventListener("resize", checkEnabled)
  }, [minWidth, maxWidth])

  return enabled
}

const useIsMobile = () => {
  return useBreakpoint({ minWidth: 0, maxWidth: 768 })
}

export default useIsMobile
